import { useState } from "react";
import ClearIcon from '@mui/icons-material/Clear';
import NotificationsIcon from '@mui/icons-material/Notifications';

const AlertCards = ({ alertData }) => {

    const [expanded, setExpanded] = useState(false);

    return (
        <div style={{
            display: 'flex', gap: 10,
            backgroundColor: "#F5F7FA",
            background: "#E8F1FB",
            borderLeft: "4px solid #1976d2",
            padding: 10, borderRadius: 5
        }}>
            <div style={{ width: 30 }}>
                <NotificationsIcon style={{ color: "#6AC9CE" }} />
            </div>

            <div style={{ flex: 1 }}>
                <div style={{
                    display: 'flex',
                    marginBottom: 20,
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <div style={{ fontWeight: 'bold' }}>
                        {alertData?.title}
                    </div>
                    <div>
                        <ClearIcon style={{ color: 'red', cursor: 'pointer' }} />
                    </div>
                </div>

                {/* Description with Show More / Show Less */}
                <div style={{ marginBottom: 20 }}>
                    <div
                        style={{
                            display: '-webkit-box',
                            WebkitLineClamp: expanded ? 'none' : 3,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden'
                        }}
                    >
                        {expanded
                            ? alertData?.description
                            : alertData?.description?.slice(0, 180)
                        }
                        {!expanded && alertData?.description?.length > 180}
                    </div>

                    {alertData?.description?.length > 180 && (
                        <span
                            onClick={() => setExpanded(!expanded)}
                            style={{
                                color: '#1976d2',
                                cursor: 'pointer',
                                fontWeight: 500
                            }}
                        >
                            {expanded ? ' Show Less' : '...Show More'}
                        </span>
                    )}
                </div>

                <div style={{
                    display: 'flex',
                    marginBottom: 20,
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <div>
                        <span style={{ fontWeight: 'bold', color: '#1976d2' }}>
                            Mark as Read
                        </span>
                    </div>
                    <div>{alertData?.alertDate}</div>
                </div>
            </div>
        </div>
    )
}

export default AlertCards;